import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { PiChartDonut, PiDotsThreeCircle, PiHouse, PiChartPieSlice } from 'react-icons/pi';
import PropTypes from 'prop-types';
import { useMobileNavigationStyle } from '../../hooks/useMobileNavigationStyle';
import './styles.css';

const items = [
  { to: '/dashboard', label: 'Início', icon: PiHouse, end: true },
  { to: '/movimentacoes', label: 'Movimentos', icon: PiChartDonut },
  { to: '/planejamento', label: 'Planejar', icon: PiChartPieSlice },
  { to: '/profile', label: 'Mais', icon: PiDotsThreeCircle },
];

const DESKTOP_NAV_ROUTES = ['/dashboard'];

const AppNavigation = ({ placement = 'global', variant }) => {
  const location = useLocation();
  const [preferredVariant] = useMobileNavigationStyle();
  const showOnDesktop = DESKTOP_NAV_ROUTES.includes(location.pathname);
  const resolvedVariant = placement === 'global' ? (variant || preferredVariant) : 'standard';

  return (
    <nav
      className={
        'nf-app-navigation nf-app-navigation--' + placement +
        ' nf-app-navigation--' + resolvedVariant + ' ' +
        (showOnDesktop ? 'nf-app-navigation--desktop-visible' : 'nf-app-navigation--desktop-hidden')
      }
      aria-label="Navegação principal"
      data-navigation-variant={resolvedVariant}
    >
      <div className="nf-app-navigation__inner">
        {items.map(({ to, label, icon: Icon, end }) => (
          <NavLink
            key={label}
            to={to}
            end={end}
            className={({ isActive }) => 'nf-app-navigation__item ' + (isActive ? 'is-active' : '')}
          >
            <Icon size={23} aria-hidden="true" />
            <span>{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
};

AppNavigation.propTypes = {
  placement: PropTypes.oneOf(['global', 'header']),
  variant: PropTypes.oneOf(['standard', 'pill']),
};

export default AppNavigation;
